/** Palette partagée par les écrans du tunnel d'inscription (alignée sur Login/Register). */
export const signupPalette = {
    primary: '#2D9CC9',
    secondary: '#8BBE1E',
    dark: '#031323',
    background: '#f8fafc',
    surface: '#ffffff',
    border: '#e2e8f0',
    textPrimary: '#0f172a',
    textSecondary: '#64748b',
    textMuted: '#94a3b8',
} as const;

/** Dégradé des boutons principaux et des pastilles d'étape. */
export const signupGradient = `linear-gradient(135deg, ${signupPalette.primary}, ${signupPalette.secondary})`;
